@use '@lib/assets/styles/main.scss' as *;

.chipsList {
  @extend %chipsList;
}
